import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { UpperCasePipe } from '@angular/common';
import { TranslocoModule, TranslocoService } from '@jsverse/transloco';
import { ErrorCodeEnum } from '@core/enums/error-code.enum';
import { CoreStore } from '@core/store/core.store';
import { authPageEvents } from '@core/store/core.events';
import { injectDispatch } from '@ngrx/signals/events';
import { ConfigService } from '@core/services/config.service';
import { WINDOW } from '@core/tokens';
import { ButtonComponent } from '@nesea/ngx-ui-kit/button';
import { AuthAsideComponent } from '@shared/components/auth-aside/auth-aside.component';

@Component({
  selector: 'nsf-error-page',
  templateUrl: './error-page.component.html',
  styleUrl: './error-page.component.scss',
  imports: [
    UpperCasePipe,
    TranslocoModule,
    ButtonComponent,
    AuthAsideComponent
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ErrorPageComponent {

  private _coreStore = inject(CoreStore);
  private _dispatch = injectDispatch(authPageEvents);
  private _window: Window = inject(WINDOW);
  private _configService: ConfigService = inject(ConfigService);
  private _translocoService: TranslocoService = inject(TranslocoService);

  protected readonly errorCode = this._coreStore.errorCode;
  protected readonly user = this._coreStore.user;

  protected readonly variant = computed(() => this.errorCode() ?? ErrorCodeEnum.NOT_FOUND);
  protected readonly isNotFound = computed(() => this.variant() === ErrorCodeEnum.NOT_FOUND);
  protected readonly isForbidden = computed(() => this.variant() === ErrorCodeEnum.FORBIDDEN);

  protected readonly supportEmail = computed(() => this._configService.config.contact?.technicalSupportEmail ?? '');

  protected readonly supportUrl = computed(() => {
    const email: string = this._configService.config.contact?.technicalSupportEmail ?? '';

    return `mailto:${email}`;
  });

  onBack(): void {
    if(this._window.history.length > 1) this._window.history.back();
    else this.onDashboard();
  }

  onDashboard(): void {
    this._dispatch.dashboardRequested();
  }

  onLogin(): void {
    this._dispatch.loginRedirectRequested(undefined);
  }

  onRequestAccess(): void {
    this._window.location.href = this.supportUrl();
  }

}